'use strict';

angular.module('docketbook').controller('createConnectionModalController', function (addressBookService, $rootScope, $scope, $state, Upload, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {
  const blankConnection = () => ({ emailAddress: '', fullName: '', organisationName: '' })

  $scope.newConnections = [blankConnection()]
  $scope.connectionsImport = { loading: false }
  $scope.importMode = false
  $scope.file = null


  $scope.$parent.showCreateConnectionsModal = function (importMode, successCb) {
    $scope.importMode = importMode
    $scope.file = null
    $scope.successCb = successCb
    $scope.importStage = 0
    $scope.newConnections = [blankConnection()]
    $('#createConnectionModal').fadeIn(100)
  }

  $scope.close = function () {
    $('#createConnectionModal').fadeOut(100)
  }

  $scope.addBlankConnection = function () {
    $scope.newConnections.push(blankConnection())
  }

  $scope.send = function () {

    var errorFound = false
    $scope.newConnections.forEach(connection => {
      var thisEmail = connection.emailAddress
      var isEmail = false;
      var isMobile = false;

      if (thisEmail) {
        var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        if (thisEmail.indexOf('@') != -1 && thisEmail.indexOf('.') != -1) {
          isEmail = true;
        }
        if (thisEmail.length == 10) {
          var foundNotANumber = false;
          for (var j = 0; j < thisEmail.length; j++) {
            if (numbers.indexOf(thisEmail[j]) == -1) {
              foundNotANumber = true;
              break;
            }
          }
          if (!foundNotANumber) {
            isMobile = true;
          }
        }
      }
      if (!isEmail /*&& !isMobile*/) {
        swal({
          title: "Hold Up!",
          text: "Some connections do not contain a valid email",
          type: "warning",
          confirmButtonText: "Ok"
        });
        errorFound = true
        return
      }
    })

    if (!errorFound) {
      addressBookService.createConnections($scope.newConnections,
        function () {
          $scope.close()
          $scope.successCb && $scope.successCb()
        },
        function () {
          swal({
            title: "Oops!",
            text: "There was an error creating connection requests.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        })
    }
  }



  const mapping = {
    'full name': 'fullName',
    'email': 'emailAddress',
    'organisation name': 'organisationName'
  }

  const reverseMapping = {}

  Object.keys(mapping)
    .forEach(key => {
      reverseMapping[mapping[key]] = key
    })


  const readTableHeaders = fileData => {
    const headers =
      fileData.shift()
        .map(header => header.toLowerCase())
        .map(header => {
          var found = null
          Object.keys(mapping).forEach(key => {
            if (header.includes(key)) {
              found = mapping[key]
              return
            }
          })
          return found
        })
        .filter(x => x !== null)

    const headerMissing = str => !headers.includes(str)

    const missing = Object.keys(reverseMapping).filter(headerMissing).map(header => reverseMapping[header])

    if (missing.length > 0) {
      swal({
        title: "Oops!",
        text: `The following columns are missing from the file: ${missing.join(', ')}`,
        type: "error",
        confirmButtonText: "Ok, got it."
      });
      $scope.connectionsImport.loading = false
      return null
    }

    return fileData.map(data => {
      var item = {}
      headers.forEach((header, i) => {
        item[header] = data[i]
      })
      return item
    })
  }

  $scope.importFromFile = function (fromFile) {
    $scope.connectionsImport.loading = true

    Upload.upload({
      url: '/v1/parse',
      data: { file: fromFile },
      withCredentials: true
    }).then(function (resp) {
      var data = readTableHeaders(resp.data[0].data)

      if (data == null) {
        return
      }

      $scope.newConnections = data

      $scope.connectionsImport.loading = false;
      $scope.importMode = false

    }, function (resp) {
      $scope.connectionsImport.loading = false;
      $scope.alertService.presentAutoAlert('readFile', resp);
    });
  }
})



// WEBPACK FOOTER //
// ./src/controllers/modals/createConnectionModalController.js